import { Component, OnInit } from '@angular/core';
import { UserService } from '../../areas/user/auth/providers/user.service';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss']
})

export class PageNotFoundComponent implements OnInit {

    public isLoggedIn: boolean;

    constructor(private userService: UserService) {
        this.isLoggedIn = false;
    }

    async ngOnInit() {
        this.isLoggedIn = !!this.userService.getUser();
    }
}
